import { rage, useObservable } from '~/rage';
import { calcOldPrice } from '../CaseItem';
import { ShopBanner } from '../ShopBanner';
import { ShopDonateItem } from '../ShopDonateItem';
import {
	StyledContainer,
	StyledDonateItemsContainer,
} from './ShopDonate.styled';

const ShopDonate = () => {
	const currencyShopItems = useObservable(rage.donate.getCurrencyShopItems());

	return (
		<StyledContainer>
			<ShopBanner />
			<StyledDonateItemsContainer>
				{currencyShopItems.map((item) => (
					<ShopDonateItem
						key={item.id}
						name={item.name}
						amount={item.amount}
						price={item.price}
						oldPrice={calcOldPrice(item.price, item.discount ?? undefined)}
						discount={item.discount ?? undefined}
						dateDiscountEnd={item.discountTimestampEnd ?? undefined}
						tags={item.tags}
						donateItemPayload={{
							id: item.id,
							name: item.name,
							amount: item.amount,
							price: item.price,
							oldPrice: calcOldPrice(item.price, item.discount ?? undefined),
						}}
					/>
				))}
			</StyledDonateItemsContainer>
		</StyledContainer>
	);
};

export { ShopDonate };
